<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> cliente <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content >
  <ng-template *ngIf="action === 'Delete'">
    Seguro quiere eliminar al sujeto obligado <b>{{LOCAL_DATA.correoElectronico}}</b>?
  </ng-template>

  <cliente [action]="action" [(tipo)]="tipo" [(cliente)]="LOCAL_DATA" [sujetoObligado]="sujetoObligado" (clientChange)="LOCAL_DATA=$event"
  (tipoChange)="tipo=$event"
  [eventoRecibido]="eventoDesdePadre"> </cliente>

<div mat-dialog-actions >
  <button mat-button (click)="doAction()" *ngIf="action != 'View'"
  [disabled]="tipo==null"
  >{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
